import { render, staticRenderFns } from "./editEmail.vue?vue&type=template&id=81a89f52&scoped=true&"
import script from "./editEmail.vue?vue&type=script&lang=js&"
export * from "./editEmail.vue?vue&type=script&lang=js&"
import style0 from "./editEmail.vue?vue&type=style&index=0&id=81a89f52&lang=less&scoped=true&"
import style1 from "./editEmail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a89f52",
  null
  
)

export default component.exports